import { render, staticRenderFns } from "./EmailEventsGroup.vue?vue&type=template&id=7c4a5c18&"
import script from "./EmailEventsGroup.vue?vue&type=script&lang=ts&"
export * from "./EmailEventsGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports